import take from "./take.js";
const take1 = take(1);
export default take1;
